module.exports = __webpack_public_path__ + "static/media/make-group.01eb48b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/make-group.svg
// module id = 3162
// module chunks = 7